"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ChevronRightMedium = _interopRequireDefault(require("../../Icon/core/ChevronRightMedium"));

var _classnames = _interopRequireDefault(require("classnames"));

var _convertUnsafeMethod = _interopRequireDefault(require("../../utils/convertUnsafeMethod"));

var _createId = _interopRequireDefault(require("../../utils/createId"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _focusRing = _interopRequireDefault(require("../../utils/focusRing"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _class, _class2, _temp;

var AccordionItem =
/**
 * An AccordionItem component represents an item in an accordion
 */
(0, _convertUnsafeMethod["default"])(_class = (0, _focusRing["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(AccordionItem, _Component);

  function AccordionItem(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AccordionItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(AccordionItem).call(this, props));
    _this.headerId = (0, _createId["default"])();
    _this.contentId = (0, _createId["default"])();
    return _this;
  }

  (0, _createClass2["default"])(AccordionItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          onItemClick = _this$props.onItemClick,
          header = _this$props.header,
          selected = _this$props.selected,
          disabled = _this$props.disabled,
          ariaLevel = _this$props.ariaLevel,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "className", "onItemClick", "header", "selected", "disabled", "ariaLevel"]);
      return _react["default"].createElement("div", (0, _extends2["default"])({}, (0, _filterDOMProps["default"])(otherProps), {
        className: (0, _classnames["default"])('spectrum-Accordion-item', 'react-spectrum-Accordion-item', {
          'is-open': selected,
          'is-disabled': disabled
        }, className),
        role: "presentation"
      }), _react["default"].createElement("h3", {
        className: "spectrum-Accordion-itemHeading",
        "aria-level": ariaLevel
      }, _react["default"].createElement("button", {
        id: this.headerId,
        className: "spectrum-Accordion-itemHeader",
        "aria-controls": this.contentId,
        "aria-expanded": selected,
        disabled: disabled,
        type: "button",
        onClick: !disabled ? onItemClick : null
      }, header), _react["default"].createElement(_ChevronRightMedium["default"], {
        role: "presentation",
        size: null,
        className: "spectrum-Accordion-itemIndicator"
      })), _react["default"].createElement("div", {
        id: this.contentId,
        role: "region",
        "aria-labelledby": this.headerId,
        "aria-hidden": !selected,
        "aria-expanded": selected,
        className: "spectrum-Accordion-itemContent"
      }, selected ? children : null));
    }
  }]);
  return AccordionItem;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * A string or node which will be placed at the top of the accordion item.
   */
  header: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Whether or not the accordion item is selected. Causes the item to expand.
   */
  selected: _propTypes["default"].bool,

  /**
   * Disables the accordion item, making it grey and uninteractable.
   */
  disabled: _propTypes["default"].bool,

  /**
   * The aria heading level of the AccordionItem. Defines the elements position
   * within a hierarchy. Set by ariaLevel prop in the parent Accordion
   * rather than directly on the component itself.
   */
  ariaLevel: _propTypes["default"].number,

  /**
   * The behavior executed upon click on the AccordionItem. Set by the parent Accordion component.
   */
  onItemClick: _propTypes["default"].func
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  header: '',
  selected: false,
  disabled: false,
  onItemClick: function onItemClick() {}
}), _temp)) || _class) || _class;

exports["default"] = AccordionItem;